import { create } from 'zustand';

interface SearchStore {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  filterOnlyFacets: Array<string>;
  setFilterOnlyFacets: (value: Array<string>) => void;
  ratingOverrides: Record<string, number>;
  setRatingOverride: (assetId: string, rating: number) => void;
  clearRatingOverride: (assetId: string) => void;
  clearRatingOverrides: () => void;
}

export const useSearchStore = create<SearchStore>((set, _get) => ({
  searchQuery: '',
  setSearchQuery: (value: string) =>
    set((state) => ({
      ...state,
      searchQuery: value,
    })),
  filterOnlyFacets: [],
  setFilterOnlyFacets: (value: Array<string>) =>
    set((state) => ({
      ...state,
      filterOnlyFacets: value,
    })),
  ratingOverrides: {},
  setRatingOverride: (assetId: string, rating: number) =>
    set((state) => ({
      ...state,
      ratingOverrides: {
        ...state.ratingOverrides,
        [assetId]: rating,
      },
    })),
  clearRatingOverride: (assetId: string) =>
    set((state) => {
      if (!Object.prototype.hasOwnProperty.call(state.ratingOverrides, assetId)) {
        return state;
      }
      const { [assetId]: _removed, ...rest } = state.ratingOverrides;
      return { ...state, ratingOverrides: rest };
    }),
  clearRatingOverrides: () =>
    set((state) => {
      if (Object.keys(state.ratingOverrides).length === 0) {
        return state;
      }
      return { ...state, ratingOverrides: {} };
    }),
}));
